import { render, staticRenderFns } from "./ImageViewBig.vue?vue&type=template&id=860f10e4&scoped=true&"
import script from "./ImageViewBig.vue?vue&type=script&lang=js&"
export * from "./ImageViewBig.vue?vue&type=script&lang=js&"
import style0 from "./ImageViewBig.vue?vue&type=style&index=0&id=860f10e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860f10e4",
  null
  
)

export default component.exports